/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "weather-rain-c500e6cf--sprite",
  "use": "weather-rain-c500e6cf--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"weather-rain-c500e6cf--sprite\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g><g transform=\"translate(17502 11134.5)\"><g transform=\"translate(-17493 -11126)\"><g transform=\"translate(5.2 15)\"><line x1=\"1.1\" y2=\"3.1\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"1\" /><line x1=\"1.8\" y2=\"5\" transform=\"translate(3.1)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"1\" /><line x1=\"1.1\" y2=\"3.1\" transform=\"translate(7.5)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"1\" /></g></g><path d=\"M24.555,11.127a3.667,3.667,0,0,1-3.53,1.948H3.434A3.191,3.191,0,0,1,.328,11.014a5.293,5.293,0,0,1,1.1-5.478,4,4,0,0,1,4.038-.96A4.772,4.772,0,0,1,7.754.736a6.346,6.346,0,0,1,7.4,1.073,5.2,5.2,0,0,1,1.355,4.122s0,.311.424.339.452-.2.508-.452a4.97,4.97,0,0,0-.819-3.7,3.643,3.643,0,0,1,3.642.254A3.117,3.117,0,0,1,21.731,5.65a3.331,3.331,0,0,1,2.457,1.327A4.066,4.066,0,0,1,24.555,11.127Z\" transform=\"translate(-17495.986 -11126.503)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
